import { Link, NavLink } from 'react-router-dom';
import { company } from '../data/company';

export function SiteHeader() {
  return (
    <header className="site-header">
      <Link className="brand" to="/" aria-label={`${company.name} home`}>
        <span className="brand-mark">2x</span>
        <span>{company.name}</span>
      </Link>
      <nav className="nav-links" aria-label="Primary navigation">
        <NavLink to="/" end>Home</NavLink>
        <NavLink to="/apps">Apps</NavLink>
        <NavLink to="/privacy">Privacy</NavLink>
        <NavLink to="/terms">Terms</NavLink>
      </nav>
    </header>
  );
}
